export class PaymentError extends Error {
  response: {
    status: number;
    data: {
      messageCode: string;
      paymentCode: string;
    };
  };

  constructor(
    message?: string,
    response?: {
      status: number;
      data: { messageCode: string; paymentCode: string };
    }
  ) {
    super(message);

    this.name = this.constructor.name;
    Error.captureStackTrace(this, this.constructor);

    this.response = response || {
      status: 500,
      data: { messageCode: '', paymentCode: '' },
    };
  }
}
